<template>
  <div class="dividends-success container container_30">
    <div class="dividends-success__icon">
      <div class="icon__circle"></div>
    </div>
    <div class="dividends-success__title">{{ i18n.divid_success_title() }}</div>
    <div class="dividends-success__sub-title">{{ i18n.divid_success_sub_title() }}</div>
    <div class="dividends-success__text">{{ i18n.divid_success_text() }}</div>
    <div class="btn-wrap margin-top">
      <md-button class="btn md-primary" to="/history">{{ i18n.lbl_history() }}</md-button>
    </div>
  </div>
</template>

<script>
  import { commonEvents } from '@js/events/common_events'
  import { i18n } from '@js/i18n'

  export default {
    name: 'dividends-page-success',
    data: _ => ({
      i18n
    }),
    created () {
    },
    methods: {
      backToSale () {
        this.$emit(commonEvents.dividendsPageStatus, false)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~scss/mixins";
  @import "~scss/variables";

  .dividends-success {
    width: 640px;
    margin: 80px auto auto;
    padding: 60px 70px;
    text-align: center;
    color: $col-text-bright;

    &__title {
      margin: 20px auto 10px;
      font-size: 32px;
      line-height: 150%;
      font-weight: 600;
    }

    &__sub-title {
      margin: 10px auto;
      font-size: 20px;
      line-height: 150%;
      font-weight: 600;
      text-align: left;
    }

    &__text {
      margin: 10px auto;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
    }

    &__actions {
      margin-top: 20px;
    }

    &__icon {
      width: 46px;
      height: 46px;
      margin: 0 auto;
      padding: 11px 0;
      background-color: $green;
      border-radius: 46px;
    }

    & .icon__circle {
      width: 24px;
      height: 18px;
      margin: 2px auto;
      background: url("/static/img/old/confirm_icon_big.svg") no-repeat center center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/sales/sale_details/components/DividendsPageSuccess.vue